import { v4 } from 'uuid'
import { useSettings } from 'Settings'

const drawLines = (n, f) => {
	let lines = []
	for (let i = 0; i < n; ++i) {
		let line = f(i)
		lines.push(<line key={v4()} {...line} />)
	}

	return lines
}

const VoltageDiagram = ({ rect }) => {
	const title_transform = `translate(${rect.x - 10}, ${rect.y - rect.height / 2}) rotate(270)`

	return (
		<>
		<text textAnchor="middle" transform={title_transform}>Voltage</text>
		<line x1={ rect.x } y1={ rect.y - rect.height } x2={ rect.x } y2={ rect.y } />
		{drawLines(rect.graph.height * 5, (i) => {
			let y = (rect.y - rect.height) + i * (rect.height / (rect.graph.height * 5))
			let length = i % 5 === 0 ? 5 : 2
			return {
				x1 : 50,
				x2: 50 + length,
				y1 : y,
				y2: y
			} })}
		<line x1={ rect.x } y1={ rect.y } x2={ rect.x + rect.width } y2={ rect.y } />
		{drawLines(45, (i) => {
			const x = rect.x + i * rect.width / 45
			const length = i % 5 === 0 ? 5 : 2
			return {
				x1 : x,
				x2: x,
				y1 : 450,
				y2: 450 - length
			} })}

		{drawLines(9, (i) => {
			let x = rect.x + (i + 1) * rect.width / 9
			return {
				x1 : x,
				x2: x,
				y1 : rect.y - rect.height,
				y2: rect.y,
				stroke: 'grey'
			} })}
		</>
	)
}

const LevelDiagram = ({ rect, name }) => {
	const title_transform = `translate(${rect.x - 10 }, ${rect.y - rect.height / 2}) rotate(270)`
	return (
		<>
			<text textAnchor="middle" transform={title_transform}>Level</text>
			<text textAnchor="middle" y={rect.y + 20} x={rect.x + 30}>{name}</text>
			<line x1={rect.x} x2={rect.x} y1={rect.y - rect.height} y2={rect.y} />
			<line x1={rect.x} y1={rect.y - rect.height} x2={rect.x + 5} y2={rect.y - rect.height} />
			<line x1={rect.x} y1={rect.y} x2={rect.x + rect.width} y2={rect.y} />
		</>
	)
}

const drawHeaders = (headers) => {
	let x = 125

	return headers.map((header) => {
		let _x = x
		x += 150
		return (<text key={v4()} x={_x} y="30" textAnchor="middle">
			{header}
			</text>)
	})
}

const Headers = () => {
	const [settings] = useSettings()
	const s = settings['supervisory']
	const headers = [
		"Start-Up",
		s['always connect'].value ? "Connect Application" : "Maintain STS",
		"Operating",
		"No Input",
		"Appl Restart",
		"Operating",
		"VSUP Sleep",
		"No Input",
		"Shut-Down"
	]

	return (<>{drawHeaders(headers)}</>)
}

export { VoltageDiagram, LevelDiagram, Headers }
